/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'
import * as Yup from 'yup'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { useAddTwoFactorMutation } from 'api/account'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    form: RefObject<FormikProps<{ code: string }>>,
    twoFactorType: string
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function AddTwoFactorCodeForm({ form, twoFactorType }: Props) {
    const { twoFactor: { identifier, type, setup: { secret } } } = useAppSelector((state) => state.account)
    const [addTwoFactor] = useAddTwoFactorMutation({ fixedCacheKey: `add-two-factor-${twoFactorType}` })

    return (
        <Formik
            innerRef={form}
            initialValues={{
                code: ''
            }}
            validationSchema={
                Yup.object({
                    code: Yup.string()
                        .required('Required')
                })
            }
            onSubmit={({ code }) => {
                addTwoFactor({ type, identifier, secret, code, is_primary: true })
            }}
        >
            {({ isSubmitting }) => (
                <Form id={'addTwoFactorCodeForm'}>
                    <Field
                        label={'Verification Code'}
                        name={'code'}
                        type={'text'}
                        disabled={isSubmitting}
                        component={NXUIForm.InputField}
                    />
                </Form>
            )}
        </Formik>
    )
}
